/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Recipient_Not_FoundInputs */

const en_mail_admin_recipient_not_found = /** @type {(inputs: Mail_Admin_Recipient_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week user with an email address not found.`)
};

const de_mail_admin_recipient_not_found = /** @type {(inputs: Mail_Admin_Recipient_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching-Week-Nutzer mit E-Mail-Adresse nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Matching Week user with an email address not found." |
*
* @param {Mail_Admin_Recipient_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_recipient_not_found = /** @type {((inputs?: Mail_Admin_Recipient_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Recipient_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_recipient_not_found(inputs)
	return en_mail_admin_recipient_not_found(inputs)
});